import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import fetchRetry$1 from '../external_node_modules/fetch-retry/index.js';
import { EVENTS } from '../constants/events.js';
import events from '../core/event/index.js';
import settings from '../settings.js';
import { log } from '../utils/logger.js';

const fetchRetry = fetchRetry$1(fetch);
const METHODS = {
    GET: 'GET',
    POST: 'POST',
};
const RETRY_STATUS_CODES = [502, 503, 504];
const LONG_POLL_RETRY_STATUS_CODES = [502, 503, 504];
const LONG_POLL_RECONNECT_STATUS_CODES = [408];
function extractErrorCode(text) {
    try {
        const json = JSON.parse(text) || {};
        return json.detail === 'error' && json.code ? json.code : text;
    }
    catch (err) { }
    return text;
}
function randomNumberBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function getBackoffOptions(retryStatusCodes = []) {
    return {
        retries: settings.requestMaxAttempts,
        retryDelay: (attempt) => {
            return Math.pow(2, attempt) * 1500 + randomNumberBetween(500, 2000);
        },
        retryOn: (attempt, error, response) => {
            if (retryStatusCodes.includes(response.status)) {
                log(`Retrying, attempt number ${attempt + 1}`);
                return attempt <= settings.requestMaxAttempts; // with the current implementation of retryOn as a function, the retries argument is ignored
            }
        },
    };
}
function makeRequest(method, url, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const requestObject = Object.assign({ method, headers: {
                'Content-Type': 'application/json',
            }, credentials: 'include', redirect: 'follow' }, getBackoffOptions(RETRY_STATUS_CODES));
        if (data) {
            requestObject.body = JSON.stringify(data);
        }
        log('[Api]', 'Request', url, 'with data =', data);
        const response = yield fetchRetry(url, requestObject);
        if (response.status !== 200) {
            const code = extractErrorCode(yield response.text());
            events.emit(EVENTS.REQUEST_ERROR, { code });
            throw new Error(extractErrorCode(code));
        }
        else {
            return yield response.json();
        }
    });
}
function makeLongRequest(method, url, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const requestObject = Object.assign({ method, headers: {
                'Content-Type': 'application/json',
            }, credentials: 'include', redirect: 'follow' }, getBackoffOptions(LONG_POLL_RETRY_STATUS_CODES));
        if (data) {
            requestObject.body = JSON.stringify(data);
        }
        log('[Api]', 'Create long poll request', url, 'with data =', data);
        const response = yield fetchRetry(url, requestObject);
        if (LONG_POLL_RECONNECT_STATUS_CODES.includes(response.status)) {
            log('[Api]', 'Long poll timeout. Reconnecting...');
            return yield makeLongRequest(method, url, data);
        }
        else if (response.status !== 200) {
            throw new Error(extractErrorCode(yield response.text()));
        }
        else {
            return yield response.json();
        }
    });
}

export { METHODS, makeLongRequest, makeRequest };
//# sourceMappingURL=baseRequest.js.map
